import React from "react";
import "./contact.css";

export default function Contact() {
  return (
    <div className="col-5 gy-5 contact" id="contact">
      <h1>Send me a message!</h1>
      <p>Got a question or proposal, or just want to say Hello? Go ahead.</p>
      <form className="row g-3">
        <div className="col-md-6">
          <label for="exampleFormControlInput1" className="form-label">
            Your Name
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter your name"
          ></input>
        </div>
        <div className="col-md-6">
          <label for="exampleFormControlInput1" className="form-label">
            Email Address
          </label>
          <input
            type="email"
            className="form-control"
            id="exampleFormControlInput1"
            placeholder="Enter your email address"
          ></input>
        </div>
        <div class="mb-3">
          <label for="exampleFormControlTextarea1" class="form-label">
            Your text
          </label>
          <textarea
            className="form-control"
            id="exampleFormControlTextarea1"
            rows="3"
            placeholder="Hi, i think we need a website for our Company X. How soon can you hop on to discuss this?"
          ></textarea>
        </div>
        <div>
          <button type="submit" class="btn btn-outline-info">
            Get in touch
          </button>
        </div>
      </form>
    </div>
  );
}
